import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type BookingDetails = {
  latitude: string;
  longitude: string;
  checkInDate: string;
  checkOutDate: string;
  roomQuantity: string;
  guestQuantity: string;
  description?: string;
};

export type BookingState = BookingDetails & {
  bookingType: 'instant' | 'group';
};

export const initialState: BookingState = {
  bookingType: 'instant',
  latitude: '',
  longitude: '',
  checkInDate: '',
  checkOutDate: '',
  roomQuantity: '1',
  guestQuantity: '1',
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    setBookingType: (
      state,
      { payload }: PayloadAction<BookingState['bookingType']>,
    ) => {
      state.bookingType = payload;
    },
    setBookingDetails: (state, { payload }: PayloadAction<BookingDetails>) => {
      return { ...state, ...payload };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { setBookingType, setBookingDetails, reset } =
  bookingSlice.actions;

export const bookingReducer = bookingSlice.reducer;
